
import React from 'react';
import { connect } from 'dva';
import { injectIntl } from 'react-intl';
import PanelMonitor from '../components/monitor/PanelMonitor';

const App = ({ intl, dispatch, loading, monitor, account }) => {
  return (
    <div className="container-left">
      <PanelMonitor
        intl={intl}
        dispatch={dispatch}
        loading={loading}
        monitor={monitor}
        account={account}
      />
    </div>
  );
};

export default connect(state => ({ ...state, loading: state.loading.global }))(
  injectIntl(App)
);



// WEBPACK FOOTER //
// ./src/routes/PanelMonitor.js